import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { t } from "@/content/site";
import { buildHead, homeOfferCatalogLD, faqLD, sharedOG } from "@/content/seo";

export const Route = createFileRoute("/")({
  component: () => <SitePage lang="en" />,
  head: () => {
    const head = buildHead({
      lang: "en",
      path: "/",
      title: t.en.seo.title,
      description: t.en.seo.description,
      keywords:
        "Vilamoura boat trips, Benagil cave tour, Vilamoura yacht charter, Algarve boat tours, private yacht Vilamoura, sunset cruise Vilamoura, dolphin watching Vilamoura, Morningstar yacht",
      altPath: { en: "/", pt: "/pt" },
      extraScripts: [
        { type: "application/ld+json", children: JSON.stringify(homeOfferCatalogLD("en")) },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    });
    return {
      ...head,
      links: [
        ...head.links,
        { rel: "preload", as: "image", href: sharedOG.image, fetchpriority: "high" } as any,
      ],
    };
  },
});
